import type {
	MenuItem,
	MenuItemLinkGroup,
	MenuItemLinks,
	MenuItemSubmenu,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
	NavCta,
} from '@ds-mgnl/marketing';
import { MdLock } from '@dsx/react';

export const topNavData: NavBarItem[] = [
	{
		type: 'submenu',
		label: 'Solutions',
		items: [
			{
				type: 'submenu',
				label: 'Procure to Pay',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										path: '/solutions/procure-to-pay/ap-automation',
										value: '/solutions/procure-to-pay/ap-automation',
										label: 'AP Automation',
										openInNewTab: false,
									},
									{
										path: '/solutions/procure-to-pay/inventory-management',
										value: '/solutions/procure-to-pay/inventory-management',
										label: 'Inventory Management',
										openInNewTab: false,
									},
									{
										path: '/solutions/procure-to-pay/supply-chain-management',
										value: '/solutions/procure-to-pay/supply-chain-management',
										label: 'Supply Chain Management',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
					{ type: 'divider' },
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										path: '/solutions/procure-to-pay',
										value: '/solutions/procure-to-pay',
										label: 'All Procure-to-Pay Solutions',
										openInNewTab: false,
									},
								],
							},
						],
					} as MenuItemLinks,
				],
			} as MenuItemSubmenu,
			{
				type: 'submenu',
				label: 'Spend Optimization',
				items: [
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										path: '/solutions/spend-optimization/ai-in-procurement',
										value: '/solutions/spend-optimization/ai-in-procurement',
										label: 'AI in Procurement',
										openInNewTab: false,
									},
									{
										path: '/solutions/spend-optimization/food-procurement',
										value: '/solutions/spend-optimization/food-procurement',
										label: 'Food Procurement',
										openInNewTab: false,
									},
									{
										path: '/solutions/spend-optimization/supply-chain-consulting',
										value:
											'/solutions/spend-optimization/supply-chain-consulting',
										label: 'Supply Chain Consulting',
										openInNewTab: false,
									},
								],
							},
						] as MenuItemLinkGroup[],
					} as MenuItemLinks,
					{
						type: 'divider',
					},
					{
						type: 'links',
						linkGroups: [
							{
								links: [
									{
										path: '/solutions/spend-optimization',
										value: '/solutions/spend-optimization',
										label: 'All Spend Optimization Solutions',
										openInNewTab: false,
									},
								],
							},
						] as MenuItemLinkGroup[],
					} as MenuItemLinks,
				],
			} as MenuItemSubmenu,
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								path: '/solutions/menuing/dssi-menu-ai',
								value: '/solutions/menuing/dssi-menu-ai',
								label: 'DSSI Menu.ai',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								path: '/solutions/channel-partnerships/applied-solutions-group',
								value:
									'/solutions/channel-partnerships/applied-solutions-group',
								label: 'Applied Solutions Group',
								openInNewTab: false,
							},
						],
					},
				],
			},
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Markets',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								path: '/markets/senior-living',
								value: '/markets/senior-living',
								label: 'Senior Living',
								openInNewTab: false,
							},
							{
								path: '/markets/behavioral-health',
								value: '/markets/behavioral-health',
								label: 'Behavioral Health',
								openInNewTab: false,
							},
							{
								path: '/markets/hospitality',
								value: '/markets/hospitality',
								label: 'Hospitality',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItem,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'Resources',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								path: '/resources/blogs',
								value: '/resources/blogs',
								label: 'Expertise',
								openInNewTab: false,
							},
							{
								path: '/resources/case-studies',
								value: '/resources/case-studies',
								label: 'Success Stories',
								openInNewTab: false,
							},
							{
								path: '/testimonials',
								value: '/testimonials',
								label: 'Testimonials',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItem,
			{ type: 'divider' },
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								path: '/resources',
								value: '/resources',
								label: 'All Resources',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItem,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'About',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						links: [
							{
								path: '/about/meet-the-team',
								value: '/about/meet-the-team',
								label: 'Meet the Team',
								openInNewTab: false,
							},
							{
								path: '/about/history',
								value: '/about/history',
								label: 'History',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItem,
		],
	} as NavBarMenuItem,
	{
		type: 'link',
		link: {
			path: '/supply-chain-partners',
			value: '/supply-chain-partners',
			label: 'Supply Chain Partners',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
];

export const ctaLinks: NavCta[] = [
	{
		path: 'contact/',
		label: 'Contact us',
		value: 'contact/',
		openInNewTab: false,
	},
	{
		path: 'sign-in',
		label: 'Sign in',
		value: 'https://www.directs.com/dssi/default.aspx',
		icon: MdLock,
		openInNewTab: true,
	},
];
